<div *ngIf="recessionData">
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 5 }">
          <div edsPadding edsPaddingTop="xl">
            <div>
              <eds-title
                [level]="3"
                [isLight]="true"
                size="h4"
                edsPadding
                edsPaddingBottom="md"
                >{{ brLabels["heading-financial"] }}</eds-title
              >

              <div
                *ngFor="let slider of recessionData.financial"
                class="slider-parent-container"
              >
                <aor-indicator-slider
                  [brLabels]="brLabels"
                  [indicator]="slider"
                  (slideEvent)="update($event)"
                  (infoEvent)="showPopup($event)"
                ></aor-indicator-slider>
              </div>

              <eds-title
                [level]="3"
                [isLight]="true"
                size="h4"
                edsPadding
                edsPaddingBottom="md"
                >{{ brLabels["heading-inflation"] }}</eds-title
              >

              <div
                *ngFor="let slider of recessionData.inflation"
                class="slider-parent-container"
              >
                <aor-indicator-slider
                  [brLabels]="brLabels"
                  [indicator]="slider"
                  (slideEvent)="update($event)"
                  (infoEvent)="showPopup($event)"
                ></aor-indicator-slider>
              </div>

              <eds-title
                [level]="3"
                [isLight]="true"
                size="h4"
                edsPadding
                edsPaddingBottom="md"
                >{{ brLabels["heading-consumer"] }}</eds-title
              >

              <div
                *ngFor="let slider of recessionData.consumer"
                class="slider-parent-container"
              >
                <aor-indicator-slider
                  [brLabels]="brLabels"
                  [indicator]="slider"
                  (slideEvent)="update($event)"
                  (infoEvent)="showPopup($event)"
                ></aor-indicator-slider>
              </div>

              <eds-title
                [level]="3"
                [isLight]="true"
                size="h4"
                edsPadding
                edsPaddingBottom="md"
                >{{ brLabels["heading-business-activity"] }}</eds-title
              >

              <div
                *ngFor="let slider of recessionData.business"
                class="slider-parent-container"
              >
                <aor-indicator-slider
                  [brLabels]="brLabels"
                  [indicator]="slider"
                  (slideEvent)="update($event)"
                  (infoEvent)="showPopup($event)"
                ></aor-indicator-slider>
              </div>
            </div>
          </div>
        </div>
        <div edsCol [columnNumbers]="{ s: 4, m: 2, l: 3 }">
          <div
            class="panel"
            edsPadding
            edsPaddingRight="md"
            edsPaddingBottom="md"
            edsPaddingLeft="md"
          >
            <aor-indicator-gauge
              [recessionData]="recessionData"
              [asOfDate]="recessionData.asOfDate"
              [brLabels]="brLabels"
            ></aor-indicator-gauge>

            <div>
              <ng-template #notModified>
                <button edsButton="primary" disabled>
                  {{ brLabels["indicator-button-text"] }}
                </button>
              </ng-template>
              <ng-container *ngIf="isModified(); else notModified">
                <button (click)="resetRecessionData()" edsButton="primary">
                  {{ brLabels["indicator-button-text"] }}
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <eds-simple-modal [id]="'aor-tooltip'" aria-label="Close">
    <div modal-body [innerHTML]="tooltipBody"></div>
  </eds-simple-modal>
</div>
